import React from 'react';
import PropTypes from 'prop-types';
import ImageProp from '../../../commonComponents/propTypes/imageProp';
import ProductVariationsProp from '../../shop/propTypes/productVariationsProp';
import translate from '../../../commonComponents/translate';

function ProductItem({ t, item }) {
  const {
    isPack,
    images,
    icon,
    name,
    isOutOfStock,
    packType,
    packVariations,
    amountVariationsPerAdvancedPack,
  } = item || {};
  const isAdvancedPack = packType === 'advanced';
  const title = isAdvancedPack ? t('shop.advancedPack') : t('shop.pack');

  const showSelectVariations =
    isAdvancedPack && (!packVariations || packVariations?.length === 0);
  const showProductsInside = isAdvancedPack && packVariations?.length > 0;
  return (
    <div className="product-info">
      <img src={isPack ? images[0]?.thumb : icon?.thumb} alt={name} />
      <div className="information">
        {isPack ? <span className="badge-pack">{title}</span> : null}
        <h4 className="product-name">{name}</h4>
        {isOutOfStock ? (
          <span className="text-danger">{t('product.no.stock')}</span>
        ) : null}
        {showSelectVariations ? (
          <button
            type="button"
            className="select-products btn-select-products"
            data-pack={JSON.stringify(item)}
          >
            <div className="icon-wrapper">
              <i className="la la-plus" />
            </div>
            <div className="label-wrapper">
              <p className="label-content">{t('btn.selectYourProducts')}</p>
            </div>
          </button>
        ) : null}
        {showProductsInside ? (
          <button
            type="button"
            className="inside-products btn-products-inside"
            data-pack={JSON.stringify(item)}
          >
            {t('advancedPack.productsInside', amountVariationsPerAdvancedPack)}
          </button>
        ) : null}
      </div>
    </div>
  );
}

ProductItem.propTypes = {
  t: PropTypes.func.isRequired,
  item: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    isPack: PropTypes.bool,
    name: PropTypes.string,
    isOutOfStock: PropTypes.string,
    packType: PropTypes.string,
    images: PropTypes.arrayOf(PropTypes.shape(ImageProp.propType)),
    icon: PropTypes.arrayOf(PropTypes.shape(ImageProp.propType)),
    packVariations: PropTypes.arrayOf(
      PropTypes.shape(ProductVariationsProp.propType),
    ),
    amountVariationsPerAdvancedPack: PropTypes.number,
  }).isRequired,
};

export default translate(ProductItem);
